export default "__VITE_ASSET__CKKPFN1j__"